import React from 'react';
import {
  useBreakpoint,
  Pagination,
  PaginationCompact,
  PaginationDisplayedItemCount,
} from '@one-thd/sui-atomic-components';
import { useThdCustomer } from '@thd-olt-functional/customer-information';
import {
  useCommonContext,
  usePurchaseHistoryContext,
} from '../../hooks/useContexts';
import { getNumPages, getWindow } from '../../utils/general';
import { IPHRequest } from '../../models/purchase-history';

export const PHPagination = () => {
  const { svocID } = useThdCustomer();
  const { isTablet } = useCommonContext();
  const {
    orderHistoryData,
    orderHistoryLoaded,
    orderHistoryError,
    pHRequest,
    setPHRequest,
  } = usePurchaseHistoryContext();

  const isTabletAndDesktop = useBreakpoint('md').greater || isTablet;
  const totalNumberOfOrders =
    orderHistoryData?.orderCount || orderHistoryData?.itemsCount || 0;

  if (
    !orderHistoryLoaded ||
    orderHistoryError !== undefined ||
    totalNumberOfOrders === 0 ||
    orderHistoryData?.orders?.length === 0
  ) {
    return null;
  }

  return (
    <div className="sui-grow" data-testid="pagination-compact-and-item-count">
      <div className="sui-relative sui-flex sui-items-center sui-gap-4 sui-flex-col-reverse sm:sui-flex-row sm:sui-gap-0">
        <PaginationDisplayedItemCount
          page={pHRequest.pageNumber}
          itemsPerPage={20}
          items={totalNumberOfOrders}
        />
        {isTabletAndDesktop ? (
          <Pagination
            count={getNumPages(20, totalNumberOfOrders)}
            page={pHRequest.pageNumber}
            onChange={(_event, selectedPage: number) => {
              setPHRequest((prevState: IPHRequest) => {
                return {
                  ...prevState,
                  pageNumber: selectedPage,
                };
              });
              getWindow()?.scrollTo({ top: 0 });
              getWindow()?.sessionStorage.setItem(
                'purchaseHistoryPage',
                JSON.stringify({
                  lastPage: selectedPage,
                  ODLastVisited: undefined,
                  id: svocID,
                }),
              );
            }}
            siblingCount={1}
            boundaryCount={1}
            showFirstButton
            showLastButton
          />
        ) : (
          <PaginationCompact
            count={getNumPages(20, totalNumberOfOrders)}
            page={pHRequest.pageNumber}
            onChange={(_event, selectedPage: number) => {
              setPHRequest((prevState: IPHRequest) => {
                return {
                  ...prevState,
                  pageNumber: selectedPage,
                };
              });
              getWindow()?.scrollTo({ top: 0 });
              getWindow()?.sessionStorage.setItem(
                'purchaseHistoryPage',
                JSON.stringify({
                  lastPage: selectedPage,
                  ODLastVisited: undefined,
                  id: svocID,
                }),
              );
            }}
          />
        )}
      </div>
    </div>
  );
};
